// Datadog message text for the MOP page decisions (LESSEEPORT-1618).
// Each message states the value or decision, then what the page does as a result.

import { METHOD_OF_PAYMENT_ACH } from './documentSignPayload';

/**
 * How the lessee reached the MOP page, in words.
 * The MOP authorization redirect sets from=mop-auth and also carries cid, so it is checked first.
 * Otherwise a cid means the Dealer Integration Service built the link (DAPI-481).
 */
export const describeEntrySource = ({ cid, isMopFlow, returnUrl }) => {
  if (isMopFlow) return 'the MOP authorization link';
  if (typeof cid === 'string' && cid.trim().length > 0) return 'the Dealer API link';
  if (returnUrl) return 'an external website link';
  return 'a direct link';
};

export const methodOfPaymentDisplayName = (methodOfPayment) =>
  methodOfPayment === METHOD_OF_PAYMENT_ACH ? 'Automatic Payment' : 'Statement Billing';

// Reported by PaymentSettings when the saved payment methods could not be loaded.
export const PAYMENT_METHODS_UNKNOWN = 'unknown';

export const pageOpenedMessage = ({ appNumber, entrySource, correlationId, savedPaymentMethodCount, isDirectDebitRequired }) =>
  `MOP page opened for ${appNumber} from ${entrySource}, correlation ${correlationId}, ` +
  (savedPaymentMethodCount === PAYMENT_METHODS_UNKNOWN
    ? 'saved payment methods could not be loaded'
    : `${savedPaymentMethodCount} saved payment methods`) +
  `, Direct Debit Required: ${isDirectDebitRequired ? 'Yes' : 'No'}`;

export const directDebitRequiredMessage = (appNumber) =>
  `Direct Debit Required is in place for ${appNumber}, Automatic Payment checkbox locked`;

export const selectionMessage = (appNumber, methodOfPayment) =>
  `Lessee selected ${methodOfPaymentDisplayName(methodOfPayment)} for ${appNumber}, sending MethodOfPayment ${methodOfPayment} to ReadyDocs`;

/**
 * Describes a payment method by id, type and last four only. Example: 900001 (MasterCard ending 4242)
 */
export const describePaymentMethod = (method) => {
  if (!method) return 'unknown payment method';
  const type = method.PaymentType === 2 ? 'ACH' : method.CardBrand || 'Card';
  const lastFour = method.LastFour || 'unknown';
  return `${method.Id} (${type} ending ${lastFour})`;
};

export const paymentMethodAddedMessage = (appNumber, method) =>
  `Payment method ${describePaymentMethod(method)} added for ${appNumber} in Payix, selecting it for signing`;

export const paymentMethodAddedNotFoundMessage = (appNumber) =>
  `Payment method added for ${appNumber} in Payix but not found in the refreshed list, the lessee must select it before signing`;

export const signRejectedMessage = (appNumber, status, message) =>
  `ReadyDocs rejected signing for ${appNumber} with ${status} '${message}', shown to the lessee`;

export const envelopeReturnedMessage = (appNumber, envelopeId) =>
  `ReadyDocs returned envelope ${envelopeId || 'with no id'} for ${appNumber}, redirecting the lessee to DocuSign`;
